/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { Tooltip } from 'antd';
import { Button } from '@/uiKit';
import { CopyOutlined } from '@ant-design/icons';
import useDuplicateWorker from '@/hooks/useDuplicateWorker';
import PlaygroundReloadIcon from '../icons/PlaygroundReloadIcon';

interface IRetryRunProps {
  workerId: string;
  isPlayground: boolean;
}

function RetryRun({ workerId, isPlayground }: IRetryRunProps) {
  const { loading, rerunResults, initiateRun } = useDuplicateWorker({
    workerId,
    isPlayground
  });

  const tooltipText = isPlayground
    ? 'Duplicate Playground'
    : 'Run Again (with same inputs)';

  return (
    <Tooltip title={tooltipText} placement="topRight">
      <Button
        type="text"
        data-cy="retry-run"
        shape="default"
        className="display-flex align-center justify-center"
        loading={rerunResults.loading}
        icon={
          isPlayground ? (
            <CopyOutlined
              style={{ fontSize: '20px', color: '#7A8E9D' }}
              spin={loading}
              className="reload"
            />
          ) : (
            <PlaygroundReloadIcon spin={loading} className="reload" />
          )
        }
        onClick={() => initiateRun()}
      />
    </Tooltip>
  );
}

export default RetryRun;
